import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { NotificationCard } from 'core/components/notification-card';
import { Label } from 'core/components/label';
import { useStore } from 'core/store';
import useStyles from './umbrella-cancel-at-renewal-banner.styles';

const UmbrellaCancelAtRenewalBanner = ({ requireUmbrellaOnCurrentPolicy }) => {
  const classes = useStyles();
  const {
    account: { policies }
  } = useStore();

  if (!policies.umbrellaWillCancelAtRenewal) {
    return null;
  }

  if (requireUmbrellaOnCurrentPolicy && !policies.policy?.policyDetails?.includeUmbrella) {
    return null;
  }

  return (
    <NotificationCard type="primary">
      <div className={classes.content}>
        <Label type="smallWhite" className={classes.title}>
          This member&rsquo;s umbrella coverage will cancel at home policy renewal
        </Label>
        <Label type="smallWhite" className={classes.text}>
          This umbrella policy will cancel upon home policy renewal because their Branch auto is in cancellation or
          canceled. According to our underwriting guidelines, a member must have both home and auto insurance from
          Branch for umbrella coverage.
        </Label>
      </div>
    </NotificationCard>
  );
};

UmbrellaCancelAtRenewalBanner.propTypes = {
  requireUmbrellaOnCurrentPolicy: PropTypes.bool
};

UmbrellaCancelAtRenewalBanner.defaultProps = {
  requireUmbrellaOnCurrentPolicy: false
};

export default observer(UmbrellaCancelAtRenewalBanner);
